'use strict';

module.exports = {
  int8: Int8Array,
  int16: Int16Array,
  int32: Int32Array,
  uint8: Uint8Array,
  uint16: Uint16Array,
  uint32: Uint32Array,
  float32: Float32Array,
  float64: Float64Array,
  array: Array
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/numjs/src/dtypes.js
// module id = 99
// module chunks = 0